"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toBytes32Array = void 0;
const tslib_1 = require("tslib");
const tiny_invariant_1 = (0, tslib_1.__importDefault)(require("tiny-invariant"));
const toBytes32Array = (b) => {
    (0, tiny_invariant_1.default)(b.length <= 32, `invalid length ${b.length}`);
    const buf = Buffer.alloc(32);
    b.copy(buf, 32 - b.length);
    return Array.from(buf);
};
exports.toBytes32Array = toBytes32Array;
//# sourceMappingURL=bytes32.js.map